import virtualReducer from './slice';

export default virtualReducer;
